import logoTNV from "../assets/images/logo-tnv.png";
export async function getImageBase64(
  url: string
): Promise<`data:image/${string};base64,${string}`> {
  try {
    return await convertImageToBase64(url);
  } catch (error) {
    return await convertImageToBase64(logoTNV);
  }
}

async function convertImageToBase64(
  url: string
): Promise<`data:image/${string};base64,${string}`> {
  try {
    const response = await fetch(url);
    const blob = await response.blob();

    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const result = reader.result as string;
        if (!result.startsWith("data:image/")) {
          reject(
            new Error(
              "Formato de imagem inválido. Certifique-se de que seja uma URL de imagem."
            )
          );
        } else {
          resolve(result as `data:image/${string};base64,${string}`);
        }
      };
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    console.error("Erro ao converter a imagem para Base64:", error);
  }
}
